import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _TitleEdit;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import ReactDOM from 'react-dom';
import defer from 'lodash/defer';
import { jsx } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import Errors from '../../../../../../common/components/shared/errors/Errors';
import t from '@instructure/quiz-i18n/es/format-message';
import { withStyleOverrides } from '@instructure/quiz-common';

// =================================

// once editing is toggled this div
// is rendered & has actions that
// allow for canceling

// =================================

export var TitleEdit = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_TitleEdit = /*#__PURE__*/function (_Component) {
  function TitleEdit() {
    var _this;
    _classCallCheck(this, TitleEdit);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TitleEdit, [].concat(args));
    _defineProperty(_this, "defer", function (fn) {
      // to enable syncronous testing
      var deferFn = _this.props.deferMock || defer;
      deferFn(fn);
    });
    _defineProperty(_this, "switchOffEditing", function () {
      var fromEnterPressed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      _this.ifValidElseError(function () {
        _this.defer(function () {
          if (fromEnterPressed) {
            _this.props.saveAndPreview(fromEnterPressed);
          } else {
            // make sure they have actually left the component
            if (document.activeElement !== _this.cancelButton && document.activeElement !== _this.input) {
              _this.props.saveAndPreview();
            }
          }
        });
      });
    });
    _defineProperty(_this, "handleKeyUp", function (e) {
      if (_this.enterPressed && e.keyCode === 13) {
        return _this.switchOffEditing(true);
      }
    });
    _defineProperty(_this, "handleKeyDown", function (e) {
      if (!e.repeat && e.keyCode === 13) {
        _this.enterPressed = true;
      }
    });
    _defineProperty(_this, "handleBlur", function (e) {
      _this.switchOffEditing(false);
    });
    return _this;
  }
  _inherits(TitleEdit, _Component);
  return _createClass(TitleEdit, [{
    key: "componentDidMount",
    value:
    // todo: extract this into a shared method
    // to be used on many components
    function componentDidMount() {
      this.props.makeStyles();
      var input = ReactDOM.findDOMNode(this.input);
      // some browsers add chars so * 2 to ensure at end
      var valLength = input.value.length * 2;
      input.focus();
      input.setSelectionRange(valLength, valLength);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles();
    }
  }, {
    key: "ifValidElseError",
    value: function ifValidElseError(cb) {
      if (this.props.isValid) {
        this.props.hideError();
        cb();
      } else {
        this.props.showError();
      }
    }
  }, {
    key: "setRef",
    value: function setRef(key) {
      var _this2 = this;
      return function (node) {
        _this2[key] = node;
      };
    }
  }, {
    key: "hasErrors",
    value: function hasErrors() {
      return this.props.errorsAreShowing && this.props.errors.size > 0;
    }
  }, {
    key: "renderErrors",
    value: function renderErrors() {
      if (this.hasErrors()) {
        return jsx("div", {
          css: this.props.styles.errorsWrapper
        }, jsx(Errors, {
          errorList: this.props.errors
        }));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", {
        ref: this.setRef('wrapper'),
        css: this.props.styles.titleEditWrapper,
        onBlur: this.handleBlur,
        "data-automation": "sdk-quiz-title-edit-wrapper"
      }, jsx("div", {
        css: this.props.styles.inputWrapper
      }, jsx("input", {
        ref: this.setRef('input'),
        type: "text",
        "aria-label": t('title'),
        placeholder: t('Add a Title...'),
        value: this.props.value,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        onChange: this.props.onInputChange,
        css: this.props.styles.titleEditInput,
        "data-automation": "sdk-quiz-title-edit"
      })), this.renderErrors());
    }
  }]);
}(Component), _defineProperty(_TitleEdit, "displayName", 'TitleEdit'), _defineProperty(_TitleEdit, "componentId", "Quizzes".concat(_TitleEdit.displayName)), _defineProperty(_TitleEdit, "propTypes", {
  value: PropTypes.string.isRequired,
  isValid: PropTypes.bool.isRequired,
  showError: PropTypes.func.isRequired,
  hideError: PropTypes.func.isRequired,
  errors: ImmutablePropTypes.list.isRequired,
  errorsAreShowing: PropTypes.bool,
  onInputChange: PropTypes.func.isRequired,
  saveAndPreview: PropTypes.func.isRequired,
  deferMock: PropTypes.func,
  styles: PropTypes.object,
  makeStyles: PropTypes.func
}), _defineProperty(_TitleEdit, "defaultProps", {
  errorsAreShowing: false,
  deferMock: defer
}), _TitleEdit)) || _class);
export default TitleEdit;